export const environment = {
  baseUrl: 'http://localhost:4200',
  deployedUrl: 'https://nettest.com',
  availableLangs: [
    { iso: 'en', name: 'English' },
    { iso: 'de', name: 'Deutsch' },
  ],
  defaultLang: 'en',
  cms: {
    headers: {
      'Content-Type': 'application/json',
    },
    projectSlug: 'nt',
    type: 'strapi',
    url: 'https://portal-api.nettest.org',
    routes: {
      articles: '/articles',
      export: '/export',
      exportQueue: '/dataStream',
      feedback: '/feedback',
      menus: '/header-menus',
      municipalities: '/municipalities',
      translations: '/ui-translations',
      images: '/assets/images',
      clearExport: '/dataStream/remove',
      cookiesProject: '/cookies/project',
      cookieConsents: '/cookie-consents',
      pages: '/pages',
      pagesProject: '/pages/project',
      projects: '/projects',
      scheduleExport: '/public/mobile',
      uploads: '/upload/files',
      versions: '/versions',
    },
  },
  controlServer: {
    headers: {
      'Content-Type': 'application/json',
      'X-Nettest-Client': 'nt',
    },
    url: 'https://api.nettest.org',
    routes: {
      providers: '/nationalTable',
      history: '/reports/basic/history',
      result: '/measurementResult',
      measurementServer: '/measurementServer',
      settings: '/settings',
      speedCurve: '/mobile/graphs',
    },
  },
  cookieWidget: {
    theme: {
      altTextColor: '#0958BD',
      backgroundColor: '#ffffff',
      buttonColor: '#0958BD',
      disabledSwitchColor: '#351EB6',
      disabledSwitchButtonColor: '#9893b8',
      dropdownColor: '#0958BD',
      linkColor: '#0958BD',
      textColor: '#000000',
    },
  },
  countriesUrl:
    'https://portal-api.nettest.org/uploads/countries_a13e3c594f.json',
  production: true,
  projectTitle: 'Nettest',
  logo: {
    header: '/assets/images/logo-header.svg',
    headerSide: null,
    footer: '/assets/images/logo-footer.svg',
    map: null,
  },
  map: {
    center: [6.66, 53.33],
    styleUrl:
      'https://tileserver.nettest.com/styles/norway_world_web/style.json',
    ispStyleUrl: null,
    allStyleUrl: null,
    browserStyleUrl: null,
    zoom: 2.5,
    countiesMaxZoom: 5,
    geocoding: {
      url:
        'https://geocode.search.hereapi.com/v1/geocode' +
        '?q={query}' +
        '&at={center}',
      apiKey: '5I4w2plz9lDIxz2F7XuEjgHNk8voUubHKatZHW0sci0',
      limit: 10,
      provider: 'here',
      region: null,
    },
    municipalitiesMaxZoom: 7.5,
    hexagons10kmMaxZoom: 10,
    hexagons1kmMaxZoom: 12,
    hexagons01kmMaxZoom: 14,
    disableProviderFilter: true,
  },
  mapServer: {
    url: 'https://statistics.nettest.com/api',
    country: 'europe',
  },
  municipality: {
    mapLayout: 'horizontal',
  },
  robotsMayIndex: true,
  versionName: 'nettest/portal-frontend',
  recaptchaSiteKey: '6LfWxp8kAAAAADqlZuWchiK47Hyoq-_2cQwG3Dmz',
}
